
import {
  ContainersDiff,ContainerDiff
} from '../../types'
import Vue, { PropType } from 'vue'
const _ = require('lodash');
export default Vue.extend({
  name: 'ContDiffView',
  data() {
    return {
      tab: null,
      changedHeaders : [
        {text : "Container Name", value: 'name', width: "1vw"},
        {text : "old value", value: "from_entries", width: "100px"},
        {text : "new value", value: "to_entries", width: "300px"}
      ],
    };
  },
  components :{
  },
  methods: {
    getColor(diff){      
      if (_.isEqual(diff.from_param,diff.to_param)) return 'black'
      else if(_.isEqual(diff.from_param,[]) || diff.from_param==='') return 'green'
      else if(_.isEqual(diff.to_param,[]) || diff.to_param==='') return 'red'
      else return 'orange'
    },
    getNameWithVersion(item : ContainerDiff){
      if(item.from_version != item.to_version){
        return `${item.name}[${item.from_version} -> ${item.to_version}]`
      }else if(item.from_version){
        return `${item.name}${item.from_version}`
      }else{
        return item.name
      }
    }
  
  },
  computed: {

  },
  props:{
    contDiffs : {type : Object as PropType<ContainersDiff>, required : false}
  }
  
})
